<template>
  <div class="chatNotification">
    <div class="notificationText" v-if="chatCount === null">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
    <div v-else>
      <div v-if="chatCount > 0" class="notificationText" :class="{ animation : showAnimation}"
           @click="redirectToChat">
        Es gibt {{ chatCount }} offene Chats
      </div>
      <div class="notificationText" v-if="chatCount === 0">
        Es gibt keine offene Chats
      </div>
    </div>
    <vue-toastr ref="notificationToast"></vue-toastr>
  </div>
</template>
<script>
import VueToastr from "vue-toastr";
import firebase from 'firebase/compat/app';
import {collection, onSnapshot, orderBy, query, where} from "firebase/firestore";
import 'firebase/auth';
import {getAuth} from "firebase/auth";
import {mapActions} from "vuex";
import fb from "../firebase/init.js";

export default {
  name: 'ChatNotifications',
  props: ['clientId', 'userMail', 'userId', 'app', 'clientIdOriginal', 'userIdOriginal'],
  components: {
    VueToastr,
  },
  computed: {},
  data() {
    return {
      chatCount: null,
      showAnimation: false,
      collection: null,
      timeIntervalLowerLimit: 1,
      timeIntervalUpperLimit: 0,
      loading: false
    }
  },
  methods: {
    ...mapActions({
      changeApp: 'changeApp',
      setFbConfig: 'setFbConfig'
    }),
    redirectToChat: function () {
      window.location = window.location.origin + '/backend/chats/#allchats';
    },
    listen() {
      if (this.unwatch) {
        this.unwatch();
      }
      this.unwatch = this.$watch('$store.state.chat.app', () => {
        getAuth(this.$store.getters.getFireApp).onAuthStateChanged((user) => {
          if (user && user.displayName !== '' && this.clientId && this.$store.getters.getFireStore) {
            this.collection = collection(this.$store.getters.getFireStore.store, this.clientId.toString());
            let openChatsQuery = query(this.collection,
                where('status', "==", "open"));
            const subscriptionProccessed = onSnapshot(openChatsQuery, async (snapshot) => {
              if (localStorage.getItem('chatNotifications')) {
                if (snapshot.docs.length > 0 && parseInt(localStorage.getItem('chatNotifications')) < snapshot.docs.length) {
                  this.$refs.notificationToast.s('Es gibt neue Nachrichten im Chateingang');
                  this.showAnimation = true;
                  setTimeout(() => {
                    this.showAnimation = false;
                  }, 1050);
                }
                this.chatCount = snapshot.docs.length;
                localStorage.setItem('chatNotifications', snapshot.docs.length.toString());
              } else {
                localStorage.setItem('chatNotifications', snapshot.docs.length.toString());
                this.chatCount = snapshot.docs.length;
              }
            });
          }
        });
      });
    },
    getApp() {
      this.loading = true;
      if (!this.$store.state.chat.app) {
        var firebaseConfig = {
          apiKey: this.$props.app.fb_api_key,
          authDomain: this.$props.app.fb_auth_domain,
          databaseURL: this.$props.app.fb_database_url,
          projectId: this.$props.app.fb_project_id,
          storageBucket: this.$props.app.fb_storage_bucket,
          messagingSenderId: this.$props.app.fb_messaging_sender_id,
          appId: this.$props.app.fb_app_id,
        };

        const configCredentials = {
          userId: this.$props.userId,
          clientId: this.$props.clientId,
          userEmail: this.$props.userMail,
          originalClientId: this.$props.clientIdOriginal,
          originalUserId: this.$props.userIdOriginal,
          isAdmin: false
        };

        this.setFbConfig({firebaseConfig: firebaseConfig, configCredentials: configCredentials})
      }
    },
    getAllClientChats: async function () {
      let q = query(this.collection,
          where('lastStatusUpdateTimestamp', '>=', moment().subtract(this.timeIntervalLowerLimit, 'd').unix() * 1000),
          orderBy('lastStatusUpdateTimestamp', "desc"));

      if (this.timeIntervalUpperLimit !== 0) {
        q = query(this.collection,
            where('lastStatusUpdateTimestamp', '>=', moment().subtract(this.timeIntervalLowerLimit, 'd').unix() * 1000),
            where('lastStatusUpdateTimestamp', '<=', moment().subtract(this.timeIntervalUpperLimit, 'd').unix() * 1000),
            orderBy("lastStatusUpdateTimestamp", "desc"));
      }

      const unsubscribe = onSnapshot(q, async (querySnapshot) => {
        this.$store.commit('setAllClientMessages', querySnapshot.docs.map(doc => Object.assign({}, {documentId: doc.id, ...doc.data()})));
        this.$store.commit('setOriginalClientMessages', querySnapshot.docs.map(doc => Object.assign({}, {documentId: doc.id, ...doc.data()})));
      });
    },
    getUserChats: function () {
      let userProcessedChatsQuery = query(this.collection,
          where("userId", "==", this.$props.userId),
          where('status', "==", "processed"));

      let userWatchedChatsQuery = query(this.collection, where("watchers", "array-contains", this.$props.userId.toString()));

      // Get all chats 1 by chatagent
      const subscriptionProccessed = onSnapshot(userProcessedChatsQuery, async (querySnapshot) => {
        this.$store.commit('setAllChatAgentMessages', querySnapshot.docs.map(doc => Object.assign({}, {documentId: doc.id, ...doc.data()})));
      });
      // Get all chats watched by chatagent
      const subscriptionWatched = onSnapshot(userWatchedChatsQuery, async (querySnapshot) => {
        this.$store.commit('setAllWatchedMessagesByChatAgent', querySnapshot.docs.map(doc => Object.assign({}, {documentId: doc.id, ...doc.data()})));
      });
    },
  },
  // beforeDestroy() {
  //     this.unwatch();
  // },
  mounted() {
    this.listen();
    this.getApp();
  },
  updated() {
    this.listen();
  },
}
</script>
<style lang="scss">
.animation {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(0.8);
  animation: pulse 1s forwards;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 40px 5px #18A689;
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 5px 5px #18A689;
  }
}

.notificationText {
  margin-left: 130px;
  top: 30%;
  position: absolute;
  padding: 5px 25px 5px 25px;
  border-radius: 7px;
  border: 1px #ebebeb solid;
  background-color: #fff;
  cursor: pointer;
}
</style>
